import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { InvoiceHistory } from '../models/invoiceHistoryView';
import { Vendor } from '../models/Vendor';

@Injectable({
  providedIn: 'root',
})
export class VendorInvoiceService {
  private readonly urlPath = 'vendor-invoice';

  constructor(private httpClient: HttpClient) {}

  createForm(request: any): Observable<Vendor> {
    return this.httpClient
      .post<Vendor>(
        `${environment.apiUrl}${this.urlPath}/post-vendor-invoice`,
        this.setupRequest(request),
      )
      .pipe();
  }

  private setupRequest(request: any) {
    const formData: FormData = new FormData();

    formData.append('model', JSON.stringify(request));

    request.forEach((invoice: any, invoiceIndex: number) => {
      invoice.attachments.forEach(
        (attachment: any, attachmentIndex: number) => {
          if (attachment && attachment.file) {
            const name = `file-${invoiceIndex}`;
            formData.append(name, attachment.file);
            invoice.attachments[attachmentIndex].name = name;
          }
        },
      );
    });

    return formData;
  }

  invoiceHistory(
    fiscalYear: number,
    vendorId: number,
    prefix: string,
  ): Observable<InvoiceHistory> {
    return this.httpClient
      .get<InvoiceHistory>(
        `${environment.apiUrl}${this.urlPath}/get-invoice-history/${fiscalYear}/${vendorId}`,
      )
      .pipe();
  }

  getAllPOs(vendorId: string) {
    return this.httpClient
      .get<InvoiceHistory>(
        `${environment.apiUrl}${this.urlPath}/get-purchase-order-history/${vendorId}`,
      )
      .pipe();
  }

  checkPoForVendor(PoNumber: string, vendorId: string) {
    return this.httpClient
      .get<any>(
        `${environment.apiUrl}${this.urlPath}/check-po-for-vendor/${PoNumber}/${vendorId}`,
      )
      .pipe();
  }

  exportToPdf(formId: string): any {
    return this.httpClient
      .get(
        `${environment.apiUrl}${this.urlPath}/purchase-order-report/${formId}`,
        {
          responseType: 'blob',
        },
      )
      .pipe();
  }
}
